import { getAttributionUrl, getUnsplashUrl, getPhotographerName } from '../utils/unsplashUtils';

/**
 * Unsplash attribution overlay component
 * Displays photographer credit with link as required by Unsplash guidelines
 * 
 * @param {Object} photo - Unsplash photo object with user and links data
 * @param {string} className - Additional CSS classes (optional)
 */
export default function UnsplashAttribution({ photo, className = '' }) {
  if (!photo || !photo.user) return null;

  const photographerUrl = getAttributionUrl(photo);
  const unsplashUrl = getUnsplashUrl();
  const photographerName = getPhotographerName(photo.user);

  return (
    <div 
      className={`absolute bottom-0 right-0 z-10 ${className}`}
      style={{ pointerEvents: 'auto' }} // Ensure links are clickable
    >
      <div className="flex items-center gap-1 px-2 py-1 rounded-tl bg-black/40 backdrop-blur-sm">
        <span className="text-white/90 text-[9px] leading-tight">Photo by</span>
        <a
          href={photographerUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="text-white font-semibold hover:text-white/80 transition-colors underline text-[9px] leading-tight"
          onClick={(e) => e.stopPropagation()} // Prevent parent click handlers
        >
          {photographerName}
        </a>
        <span className="text-white/90 text-[9px] leading-tight">on</span>
        <a
          href={unsplashUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="text-white font-semibold hover:text-white/80 transition-colors underline text-[9px] leading-tight"
          onClick={(e) => e.stopPropagation()}
        >
          Unsplash
        </a>
      </div>
    </div>
  );
}

